import Vue from "vue";
import VueRouter from "vue-router";
import { getAuth } from "firebase/auth";
import HomeView from "../views/HomeView.vue";
import DashboardView from "../views/DashboardView.vue";
import HomePage from "../components/HomePage.vue";
import ActTypePage from "../components/ActTypePage.vue";
import UserPage from "../components/UserPage.vue";
import CityPage from "../components/CityPage.vue";
import StorePage from "../components/StorePage.vue";
import StoreTemplatePage from "../components/StoreTemplatePage.vue";
import LoginPage from "../components/LoginPage.vue";
import MessagePage from "../components/MessagePage.vue";
import TicketPage from "../components/TicketPage.vue";
import BannerPage from "../components/TopBannerAdsPage.vue";
import ManagerPage from "../components/ManagerPage.vue";
import PictureBoxPage from "../components/PictureBoxPage.vue";
import TermsAndPolicyPage from "../components/TermsAndPolicy.vue";
import LightBoxPage from "../components/LightBoxPage.vue";
import ExplorePage from "../components/ExplorePage.vue";
import RegisterPage from "../components/RegisterPage.vue";
import TicketLogPage from "../components/TicketLogPage.vue";
import FinishSignIn from "../components/FinishSignIn.vue";

Vue.use(VueRouter);

const router = new VueRouter({
  routes: [
    {
      path: "*",
      redirect: "/login",
    },
    {
      path: "/",
      component: DashboardView,
      children: [
        {
          path: "/",
          component: HomePage,
        },
        {
          path: "/login",
          component: LoginPage,
        },
        {
          path: "/store",
          component: StorePage,
          meta: { requiresAuth: true },
        },
        {
          path: "/user",
          component: UserPage,
          meta: { requiresAuth: true },
        },
        {
          path: "/city",
          component: CityPage,
          meta: { requiresAuth: true },
        },
        {
          path: "/explore",
          component: ExplorePage,
          meta: { requiresAuth: true },
        },
        {
          path: "/acttype",
          component: ActTypePage,
          meta: { requiresAuth: true },
        },
        {
          path: "/message",
          component: MessagePage,
          meta: { requiresAuth: true },
        },
        {
          path: "/ticket",
          component: TicketPage,
          meta: { requiresAuth: true },
        },
        {
          path: "/banner",
          component: BannerPage,
          meta: { requiresAuth: true },
        },
        {
          path: "/manager",
          component: ManagerPage,
          meta: { requiresAuth: true },
        },
        {
          path: "/picture-box",
          component: PictureBoxPage,
          meta: { requiresAuth: true },
        },
        {
          path: "/light-box",
          component: LightBoxPage,
          meta: { requiresAuth: true },
        },
        {
          path: "/register",
          component: RegisterPage,
          meta: { requiresAuth: true },
        },
        {
          path: "/ticket-log",
          component: TicketLogPage,
          meta: { requiresAuth: true },
        },
        {
          path: "/store-template",
          component: StoreTemplatePage,
          meta: { requiresAuth: true },
        },
      ],
    },
    {
      path: "/",
      component: HomeView,
      children: [
        {
          path: "/terms-and-policy",
          name: "TermsAndPolicy",
          component: TermsAndPolicyPage,
        },
        {
          path: "/finish-sign-in",
          name: "FinishSignIn",
          component: FinishSignIn,
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  if (!requiresAuth) {
    next();
    return;
  }

  const auth = getAuth();
  const unsubscribe = auth.onAuthStateChanged((user) => {
    unsubscribe();
    if (user) {
      next();
    } else {
      next({ path: "/login" });
    }
  });
});

export default router;
